import React, { useEffect, useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { API_URL } from "../../actions/auth";
import axios from "axios";

import Sidebar from "../../components/Sidebar";

import ResultsMarksTeacher from "./ResultsMarksTeacher";
import ResultsAggrTeacher from "./ResultsAggrTeacher";

import './Results.css';

export default function StudentMarks() {
  const [classes, setClasses] = useState([]);
  const [classId, setClassId] = useState("");
  const [sectionId, setSectionId] = useState("");

  const [subjects, setSubjects] = useState([]);
  const [students, setStudents] = useState([]);
  const [results, setResults] = useState([]);

  const [loadingClasses, setLoadingClasses] = useState(false);
  const [loadingMarks, setLoadingMarks] = useState(false);
  const [error, setError] = useState("");
  
  const state = useSelector((state) => state);
  const [clsdivs, setClsdivs] = useState({});
  const [res_cls, setClass] = useState("");
  const [res_div, setDivision] = useState("");
  


  const selectedClass = classes.find(
    (item) => String(item.id) === String(classId)
  );

  const sections = selectedClass?.sections || [];

  // API 1: Load classes and sections once.
  useEffect(() => {
    let active = true;
    const userCdss = JSON.parse(state.auth.user.class_id_list)
console.log(state.auth.user.subject_list)
    const userSbjs = JSON.parse(state.auth.user.subject_list)
    setClsdivs(userCdss)
    console.log(state.auth.user.is_class_teacher)
    console.log(userCdss)
    setClass(state.auth.user.class_id)
    setDivision(state.auth.user.division)

    /*
    async function loadClasses() {
      try {
        setLoadingClasses(true);

        const response = await axios.get(
          `${API_URL}/classes-sections/`
        );

        if (!active) return;

        const data = response.data;
        setClasses(data);

        if (data.length > 0) {
          setClassId(String(data[0].id));

          const firstSection = data[0].sections?.[0];
          setSectionId(
            firstSection ? String(firstSection.id) : ""
          );
        }
      } catch (err) {
        if (active) {
          setError("Unable to load classes and sections.");
        }
      } finally {
        if (active) setLoadingClasses(false);
      }
    }

    loadClasses();
    */

    return () => {
      active = false;
    };
  }, []);

  // API 2: Reload marks when class or section changes.
  useEffect(() => {
    if (!res_cls || !res_div) {
      setSubjects([]);
      setStudents([]);
      return;
    }

    let active = true;

    async function loadMarks() {
      try {
        setLoadingMarks(true);
        setError("");
    
    var body = {};
    const config = {
      headers: {
        Authorization: state.auth.token,

        "Content-Type": "application/json",
      },
    };
    body["exam_id"] = 'E01'
    body["tid"] = state.auth.user.user_id
    body["class_id"] = res_cls
    body["division"] = res_div
    body = JSON.stringify(body);

        const response = await axios.post(
          `${API_URL}/get_results_aggr`, body, config
        );

        if (!active) return;
        
        console.log(typeof(response.data.subjects),response.data.subjects)
        console.log(typeof(response.data.students),response.data.students)
        console.log(typeof(response.data.results),response.data.results)
    
        setSubjects(response.data.subjects || []);
        setStudents(response.data.students || []);
        setResults(response.data.results || []);
      } catch (err) {
        if (active) {
          setSubjects([]);
          setStudents([]);
          setError("Unable to load student marks.");
        }
      } finally {
        if (active) setLoadingMarks(false);
      }
    }

    loadMarks();

    return () => {
      active = false;
    };
  }, [res_cls, res_div]);

  const stats = useMemo(() => {
    let total = 0;
    let possible = 0;

    students.forEach((student) => {
      subjects.forEach((subject) => {
        const mark = student.marks?.[subject.id];

        if (
          mark !== null &&
          mark !== undefined &&
          mark !== ""
        ) {
          total += Number(mark);
          possible += Number(subject.max_marks || 0);
        }
      });
    });

    return {
      studentCount: students.length,
      subjectCount: subjects.length,
      average:
        possible > 0
          ? ((total / possible) * 100).toFixed(1)
          : "—",
    };
  }, [students, subjects]);

  function handleClassChange(c) {
    setClass(c)
    setDivision('');
    // setLoading(true)
    // getStudents(c, res_div);
  }

  function handleDivisionChange(d) {
    setDivision(d);
    let s = clsdivs[res_cls][d]
    console.log(res_cls, d, s)
    //setLoading(true);
    // getStudents(res_cls, d);
  }

  function getTotal(student) {
    return subjects.reduce((sum, subject) => {
      const mark = results?.[student?.id]?.[subject] ?? 0;
      console.log(typeof(mark),mark)

if (mark === null || mark === undefined || mark === "") {
  return sum;
}

if (typeof mark === "string") {
  const trimmed = mark.trim();
  if (trimmed === "" || isNaN(Number(trimmed))) {
    return sum;
  }
  return sum + Number(trimmed);
}

      return mark !== null &&
        mark !== undefined &&
        mark !== ""
        ? sum + Number(mark)
        : sum;
    }, 0);
  }

  function getMaxTotal() {
    return subjects.reduce(
      (sum, subject) => sum + Number(subject.max_marks || 0),
      0
    );
  }

function getAverage(student) {
  const { sum, count } = subjects.reduce(
    (acc, subject) => {
      const mark = results?.[student?.id]?.[subject];

      if (mark !== null && mark !== undefined && mark !== "") {
        const num = Number(mark); // Convert string to number
        if (!isNaN(num)) {
          return {
            sum: acc.sum + num,
            count: acc.count + 1
          };
        }
      }

      return acc;
    },
    { sum: 0, count: 0 }
  );

  if (count === 0) return 0;

  let c = 0;
  switch (res_cls){
    case 'Class 1':
    case 'Class 2':
    case 'Class 9':
    case 'Class 10': c = 6; break;
    case 'Class 3':
    case 'Class 4':
    case 'Class 5':
    case 'Class 6':
    case 'Class 7':
    case 'Class 8': c = 7; break;
  }
  console.log('getAverage: ' + res_cls + ' count: ' + c)
  const average = sum / c;
  return Number(average.toFixed(2));
}

  function getPercentage(student) {
    const max = getMaxTotal();

    if (!max) return "—";

    const hasMarks = subjects.some((subject) => {
      const mark = student.marks?.[subject.id];
      return mark !== null && mark !== undefined && mark !== "";
    });

    if (!hasMarks) return "—";

    return `${((getTotal(student) / max) * 100).toFixed(1)}%`;
  }

  if (loadingClasses) {
    return (
      <div className="p-8 text-center text-gray-500">
        Loading classes...
      </div>
    );
  }

  return (

    <div className="min-h-screen bg-gray-50 p-2 sm:p-6 lg:p-4">
      <div className="mx-auto">

        {/* Filters */}
        <div className="grid grid-cols-1 gap-2 rounded-xl border border-gray-200 bg-white p-5 shadow-sm sm:grid-cols-2 hidden">
          <div class="flex items-center gap-3">
            <label
              htmlFor="class"
              className="mb-2 block text-sm font-medium text-gray-700"
            >
              Class
            </label>
              
              <select
                id="res_cls"
                value={res_cls}
                onChange={(e) => handleClassChange(e.target.value)}
                className="rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-700 shadow-sm outline-none transition focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100"
              >
              <option value="">Select Class</option>
              {Object.keys(clsdivs).map((key) => (
                <option value={key}> {key} </option>
              ))}
              </select>

          </div>

          <div class="flex items-center gap-3">
            <label
              htmlFor="section"
              className="mb-2 block text-sm font-medium text-gray-700"
            >
              Section
            </label>
              
              <select
                id="res_div"
                value={res_div}
                onChange={(e) => handleDivisionChange(e.target.value)}
                className="rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-700 shadow-sm outline-none transition focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100"
              >
              <option value="">Select Section</option>
              {res_cls && Object.keys(clsdivs[res_cls]).map((key) => (
                <option value={key}> {key} </option>
              ))}
              </select>

          </div>
        </div>

        {/* Summary cards */}
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-3 hidden">
          <SummaryCard
            label="Total Students"
            value={stats.studentCount}
            color="blue"
          />
          <SummaryCard
            label="Total Subjects"
            value={stats.subjectCount}
            color="teal"
          />
          <SummaryCard
            label="Overall Average"
            value={
              stats.average === "—"
                ? "—"
                : `${stats.average}%`
            }
            color="violet"
          />
        </div>

        {/* Table */}
        <div className="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm">
          <div className="flex flex-col gap-2 border-b border-gray-200 px-5 py-4 sm:flex-row sm:items-center sm:justify-between hidden">
            <div>
              <h2 className="font-semibold text-gray-900">
                Marks by Subject
              </h2>
              <p className="mt-1 text-sm text-gray-500">
                {selectedClass?.name || "Class"} — Section{" "}
                {sections.find(
                  (section) => String(section.id) === sectionId
                )?.name || "—"}
              </p>
            </div>

            <span className="text-sm text-gray-500">
              {students.length} students
            </span>
          </div>

          {error && (
            <div
              role="alert"
              className="m-4 rounded-lg bg-red-50 p-3 text-sm text-red-700"
            >
              {error}
            </div>
          )}

          {loadingMarks ? (
            <div className="p-12 text-center text-sm text-gray-500">
              Loading student marks...
            </div>
          ) : !error && students.length === 0 ? (
            <div className="p-12 text-center">
              <p className="font-medium text-gray-700">
                No students found
              </p>
              <p className="mt-1 text-sm text-gray-500">
                Try selecting another class or section.
              </p>
            </div>
          ) : !error ? (
            <div id="results-print-area" className="overflow-x-auto">
              <div className="hidden print:block mb-6 text-center">
                  <h6 className="text-2xl font-bold text-black">The Cathedral High School - Bengaluru</h6>
                  <p className="text-sm text-gray-600">Consolidated Sheet First Term Exam 2026 - {res_cls} {res_div}</p>
              </div>
              <table className="min-w-full divide-y divide-gray-200 text-sm">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="whitespace-nowrap px-4 py-3 text-left font-semibold text-gray-600 hidden">
                      Roll No.
                    </th>
                    <th className="sticky left-0 z-10 min-w-48 whitespace-nowrap bg-gray-50 px-4 py-3 text-left font-semibold text-gray-600">
                      Student Name
                    </th>


{subjects.map((subject) => (
  <th
    key={subject}
    className="h-24 min-w-12 whitespace-nowrap px-1 py-1 text-center font-semibold text-gray-600 align-bottom"
  >
    <div className="flex h-full items-end justify-center">
      <span className="origin-top-left whitespace-nowrap text-sm">
        <WordList items={subject} />
      </span>
    </div>
    {/* <div className="mt-2 text-xs font-normal text-gray-400">
      Max: {subject}
    </div> */}
  </th>
))}

                    <th className="whitespace-nowrap bg-blue-50 px-4 py-3 text-center font-semibold text-blue-800">
                      Total
                    </th>
                    <th className="whitespace-nowrap bg-blue-50 px-4 py-3 text-center font-semibold text-blue-800 hidden">
                      Average
                    </th>
                  </tr>
                </thead>

                <tbody className="divide-y divide-gray-100">
                  {students.map((student) => (
                    <tr
                      key={student.id}
                      className="transition-colors hover:bg-blue-50/40"
                    >
                      <td className="whitespace-nowrap px-4 py-3 text-gray-500 hidden">
                        {student.id}
                      </td>

                      <td className="sticky left-0 z-10 whitespace-nowrap bg-white px-4 py-3 font-medium text-gray-900">
                        {student.name}
                      </td>

                      {subjects.map((subject) => {
                        const mark = results?.[student?.id]?.[subject] ?? '-';
                        const missing =
                          mark === null ||
                          mark === undefined ||
                          mark === "";

                        const belowPass =
                          !missing &&
                          Number(mark) <
                            Number(subject.max_marks || 0) * 0.35;

                        return (
                          <td
                            key={subject.id}
                            className={`px-1 py-1 text-center ${
                              missing
                                ? "text-gray-400"
                                : belowPass
                                ? "font-medium text-red-600"
                                : "text-gray-700"
                            }`}
                          >
                            {missing ? "—" : mark}
                          </td>
                        );
                      })}

                      <td className="bg-blue-50/50 px-4 py-3 text-center font-semibold text-gray-900">
                        {getTotal(student)}
                      </td>

                      <td className="bg-blue-50/50 px-4 py-3 text-center font-semibold text-blue-700 hidden">
                        {getAverage(student)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : null}

          <div className="flex justify-between border-t border-gray-200 px-5 py-3 text-xs text-gray-500">
            <span> Missing marks are displayed as dashes. </span>

            <button onClick={() => window.print()} className="rounded-lg bg-blue-600 px-5 py-2 text-sm font-semibold text-white shadow hover:bg-blue-700 print:hidden">
                  Print 
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

function SummaryCard({ label, value, color }) {
  const colors = {
    blue: "bg-blue-50 text-blue-700",
    teal: "bg-teal-50 text-teal-700",
    violet: "bg-violet-50 text-violet-700",
  };

  return (
    <div className="rounded-xl border border-gray-200 bg-white p-5 shadow-sm">
      <p className="text-sm font-medium text-gray-500">{label}</p>
      <p
        className={`mt-3 inline-flex rounded-lg px-3 py-2 text-2xl font-bold ${colors[color]}`}
      >
        {value}
      </p>
    </div>
  );
}

function WordList({ items }) {
  const words = items.trim().split(/\s+/);
  return (
    <div key={items} style={{ marginBottom: '1rem' }}>
      {words.length > 1 ? (
        <>
          {words[0]}
          <br />
          {words.slice(1).join(' ')}
        </>
      ) : (
        items
      )}
    </div>
  );
}
